import moment from 'moment'


import { AppDispatch } from '../../../store'
import Client from '../Client/Client'
import {
    SurveyObject,
  ISurveyQuestion,
} from '../Client/ISurvey'
import { SurveyTriggerType, SurveyTrigger } from '../screens/Components/EditDescriptionCard/EditDescriptionCard'

import {
  ActionTypes,
  SurveyDispatchTypes as DT,
    AddQuestion,
  DeleteQuestion,
  UpdateSurveyDescription,
  UpdateSurveyMailSubject,
  UpdateSurveyName,
  UpdateSurveyLanguage
} from './ActionTypes'



export const getSurveys = () => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.GET_SURVEYS_REQUEST,
    })

    return Client.getSurveys().then(
      (surveys: any) => dispatch(getSurveysSuccess(surveys)),
      (error: any) => {
        dispatch(getSurveysFailure())
      },
    )
  }
}

const getSurveysSuccess = (surveys: SurveyObject[]): ActionTypes => {
  return {
    type: DT.GET_SURVEYS_SUCCESS,
    payload: {
      surveys,
    },
  }
}

const getSurveysFailure = (): ActionTypes => {
  return {
    type: DT.GET_SURVEYS_FAILURE,
  }
}

export const deleteSurvey = (survey: string) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.DELETE_SURVEY,
    })

    return Client.deleteSurvey(survey).then(
      () => dispatch(deleteSurveySuccess(survey)),
      () => dispatch(deleteSurveyFailure()),
    )
  }
}

const deleteSurveySuccess = (survey: string): ActionTypes => {
  return {
    type: DT.DELETE_SURVEY_SUCCESS,
    payload: {
      survey,
    },
  }
}

const deleteSurveyFailure = (): ActionTypes => {
  return {
    type: DT.DELETE_SURVEY_FAILURE,
  }
}

export const createSurveyTriggerBeforeAppointment = (
  surveyId: string,
  type: SurveyTriggerType,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.CREATE_SURVEY_TRIGGER,
    })

    return Client.createSurveyTrigger(surveyId, type).then(
      newTrigger => dispatch(createSurveyTriggerSuccess(surveyId, {
        uuid: newTrigger.uuid,
        frequency: 'after_each_appointment',
        type: 'send_days_before_appointment',
        amount: 1,
      })),
    )
  }
}

export const createSurveyTriggerAfterAppointment = (
  surveyId: string,
  type: SurveyTriggerType,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.CREATE_SURVEY_TRIGGER,
    })

    return Client.createSurveyTrigger(
      surveyId,
      type,
    ).then(newTrigger =>
      dispatch(createSurveyTriggerSuccess(surveyId, {
        uuid: newTrigger.uuid,
        frequency: 'after_each_appointment',
        type: 'send_after_appointment',
        activityUuids: [],
        categoryIds: [],
      })),
    )
  }
}

const createSurveyTriggerSuccess = (
  surveyId: string,
  trigger: SurveyTrigger,
): {
  type: typeof DT.CREATE_SURVEY_TRIGGER_SUCCESS
  payload: {
    surveyId: string
    trigger: SurveyTrigger
  }
} => {
  return {
    type: DT.CREATE_SURVEY_TRIGGER_SUCCESS,
    payload: {
      surveyId,
      trigger,
    },
  }
}

export const deleteSurveyTrigger = (surveyId: string, triggerUuid: string) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.DELETE_SURVEY_TRIGGER,
    })

    return Client.deleteSurveyTrigger(surveyId, triggerUuid).then(() =>
      dispatch(deleteSurveyTriggerSuccess(surveyId, triggerUuid)),
    )
  }
}

const deleteSurveyTriggerSuccess = (
  surveyId: string,
  triggerUuid: string,
): ActionTypes => {
  return {
    type: DT.DELETE_SURVEY_TRIGGER_SUCCESS,
    payload: {
      surveyId,
      uuid: triggerUuid,
    },
  }
}

export const updateSurveyTrigger = (
  surveyId: string,
  trigger: SurveyTrigger,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_SURVEY_TRIGGER,
    })

    return Client.updateSurveyTrigger(surveyId, trigger).then(() =>
      dispatch(updateSurveyTriggerSuccess(surveyId, trigger)),
    )
  }
}

const updateSurveyTriggerSuccess = (
  surveyId: string,
  trigger: SurveyTrigger,
) => {
  return {
    type: DT.UPDATE_SURVEY_TRIGGER_SUCCESS,
    payload: {
      surveyId,
      trigger,
    },
  }
}

type AddSurveyObject = {
  name: string
  description: string
  mailSubject: string
  establishmentId: number
}

export const addSurvey = (survey: AddSurveyObject) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.ADD_SURVEY,
    })

    return Client.addSurvey(
      survey.name,
      survey.description,
      survey.mailSubject,
      survey.establishmentId,
    ).then(
      surveyWithId =>
        dispatch(
          addSurveySuccess({
            id: surveyWithId.id,
            establishment: [survey.establishmentId],
            name: survey.name,
            createdAt: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
            updatedAt: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
            description: survey.description,
            isSendAfterAppointment: false,
            mailSubject: survey.mailSubject,
            questions: [],
            triggers: [],
            language: 'nl',
          }),
        ),
      () => dispatch(addSurveyFailure()),
    )
  }
}

const addSurveySuccess = (survey: SurveyObject): ActionTypes => {
  return {
    type: DT.ADD_SURVEY_SUCCESS,
    payload: {
      survey,
    },
  }
}

const addSurveyFailure = (): ActionTypes => {
  return {
    type: DT.ADD_SURVEY_FAILURE,
  }
}

export const updateSurveyLanguage = (update: UpdateSurveyLanguage) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_SURVEY_LANGUAGE,
    })

    return Client.updateSurveyLanguage(update.surveyId, update.language).then(
      () => dispatch(updateSurveyLanguageSuccess(update)),
      () => dispatch(updateSurveyLanguageFailure()),
    )
  }
}

const updateSurveyLanguageSuccess = (
  survey: UpdateSurveyLanguage,
): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_LANGUAGE_SUCCESS,
    payload: {
      survey,
    },
  }
}

const updateSurveyLanguageFailure = (): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_LANGUAGE_FAILURE,
  }
}

export const updateSurveyName = (survey: UpdateSurveyName) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_SURVEY_NAME,
    })

    return Client.updateSurveyName(survey.surveyId, survey.name).then(
      () => dispatch(updateSurveyNameSuccess(survey)),
      () => dispatch(updateSurveyNameFailure()),
    )
  }
}

const updateSurveyNameSuccess = (survey: UpdateSurveyName): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_NAME_SUCCESS,
    payload: {
      survey,
    },
  }
}

const updateSurveyNameFailure = (): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_NAME_FAILURE,
  }
}

export const updateSurveyDescription = (survey: UpdateSurveyDescription) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_SURVEY_DESCRIPTION,
    })

    return Client.updateSurveyDescription(
      survey.surveyId,
      survey.description,
    ).then(
      () => dispatch(updateSurveyDescriptionSuccess(survey)),
      () => dispatch(updateSurveyDescriptionFailure()),
    )
  }
}

const updateSurveyDescriptionSuccess = (
  survey: UpdateSurveyDescription,
): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_DESCRIPTION_SUCCESS,
    payload: {
      survey,
    },
  }
}

const updateSurveyDescriptionFailure = (): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_DESCRIPTION_FAILURE,
  }
}

export const updateSurveyMailSubject = (survey: UpdateSurveyMailSubject) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_SURVEY_MAIL_SUBJECT,
    })

    return Client.updateSurveyMailSubject(
      survey.surveyId,
      survey.mailSubject,
    ).then(
      () => dispatch(updateSurveyMailSubjectSuccess(survey)),
      () => dispatch(updateSurveyMailSubjectFailure()),
    )
  }
}

const updateSurveyMailSubjectSuccess = (
  survey: UpdateSurveyMailSubject,
): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_MAIL_SUBJECT_SUCCESS,
    payload: {
      survey,
    },
  }
}

const updateSurveyMailSubjectFailure = (): ActionTypes => {
  return {
    type: DT.UPDATE_SURVEY_MAIL_SUBJECT_FAILURE,
  }
}

export const setSurveySendAfterAppointment = (
  surveyId: string,
  isSend: boolean,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.SET_SURVEY_SEND_AFTER_APPOINTMENT,
    })

    return Client.updateSurveySendAfterAppointment(surveyId, isSend).then(
      () => dispatch(setSurveySendAfterAppointmentSuccess(surveyId, isSend)),
      () => dispatch(setSurveySendAfterAppointmentFailure()),
    )
  }
}

const setSurveySendAfterAppointmentSuccess = (
  surveyId: string,
  send: boolean,
): ActionTypes => {
  return {
    type: DT.SET_SURVEY_SEND_AFTER_APPOINTMENT_SUCCESS,
    payload: {
      surveyId,
      send,
    },
  }
}

const setSurveySendAfterAppointmentFailure = (): ActionTypes => {
  return {
    type: DT.SET_SURVEY_SEND_AFTER_APPOINTMENT_FAILURE,
  }
}

export const setSurveySendBeforeAppointment = (
  surveyId: string,
  days: number,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.SET_SURVEY_SEND_BEFORE_APPOINTMENT,
    })

    return Client.updateSurveySendBeforeAppointment(surveyId, days).then(
      () => dispatch(setSurveySendBeforeAppointmentSuccess(surveyId, days)),
      () => dispatch(setSurveySendBeforeAppointmentFailure()),
    )
  }
}

const setSurveySendBeforeAppointmentSuccess = (
  surveyId: string,
  days: number | undefined,
): ActionTypes => {
  return {
    type: DT.SET_SURVEY_SEND_BEFORE_APPOINTMENT_SUCCESS,
    payload: {
      surveyId,
      days,
    },
  }
}

const setSurveySendBeforeAppointmentFailure = (): ActionTypes => {
  return {
    type: DT.SET_SURVEY_SEND_BEFORE_APPOINTMENT_FAILURE,
  }
}

export const addQuestion = (question: AddQuestion) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.ADD_QUESTION,
    })

    return Client.addQuestion(question).then(
      (newQuestion) => {
        if (newQuestion.id) {
          dispatch(
            addQuestionSuccess(
              question.surveyId,
              newQuestion as ISurveyQuestion,
            ),
          )
        }
      },
      () => dispatch(addQuestionFailure()),
    )
  }
}

const addQuestionSuccess = (
  surveyId: string,
  question: ISurveyQuestion,
): ActionTypes => {
  return {
    type: DT.ADD_QUESTION_SUCCESS,
    payload: {
      surveyId,
      question,
    },
  }
}

const addQuestionFailure = (): ActionTypes => {
  return {
    type: DT.ADD_QUESTION_FAILURE,
  }
}

export const deleteQuestion = (question: DeleteQuestion) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.DELETE_QUESTION,
    })

    return Client.deleteQuestion(question).then(
      () =>
        dispatch(deleteQuestionSuccess(question.surveyId, question.questionId)),
      () => dispatch(deleteQuestionFailure()),
    )
  }
}

const deleteQuestionSuccess = (
  surveyId: string,
  questionId: string,
): ActionTypes => {
  return {
    type: DT.DELETE_QUESTION_SUCCESS,
    payload: {
      surveyId,
      questionId,
    },
  }
}

const deleteQuestionFailure = (): ActionTypes => {
  return {
    type: DT.DELETE_QUESTION_FAILURE,
  }
}

export const updateQuestion = (question: ISurveyQuestion, surveyId: string) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_QUESTION,
    })
    return Client.updateQuestion(question, surveyId).then(
      () => dispatch(updateQuestionSuccess(surveyId, question)),
      () => dispatch(updateQuestionFailure()),
    )
  }
}

const updateQuestionSuccess = (
  surveyId: string,
  question: ISurveyQuestion,
): ActionTypes => {
  return {
    type: DT.UPDATE_QUESTION_SUCCESS,
    payload: {
      question,
      surveyId,
    },
  }
}

const updateQuestionFailure = (): ActionTypes => {
  return {
    type: DT.UPDATE_QUESTION_FAILURE,
  }
}

export const updateQuestionsOrder = (
  questions: ISurveyQuestion[],
  questionIds: string[],
  surveyId: string,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DT.UPDATE_QUESTIONS_ORDER,
    })

    return Client.updateQuestionsOrder(questions, questionIds, surveyId).then(
      () =>
        dispatch(updateQuestionsOrderSuccess(questions, questionIds, surveyId)),
      () => dispatch(updateQuestionsOrderFailure()),
    )
  }
}

const updateQuestionsOrderSuccess = (
  questions: ISurveyQuestion[],
  questionIds: string[],
  surveyId: string,
): ActionTypes => {
  return {
    type: DT.UPDATE_QUESTIONS_ORDER_SUCCESS,
    payload: {
      questions,
      questionIds,
      surveyId,
    },
  }
}

const updateQuestionsOrderFailure = (): ActionTypes => {
  return {
    type: DT.UPDATE_QUESTIONS_ORDER_FAILURE,
  }
}
